var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row px-3 mb-4" }, [
      _c("h5", { staticClass: "bold" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("drip-campaigns.modals.create.title")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "justified progress-text" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("drip-campaigns.modals.create.subtitle")) +
            "\n    "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "email-create",
        attrs: { id: "create-email-form" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            $event.stopPropagation()
          },
        },
      },
      [
        _c("div", { staticClass: "row mb-2 align-items-center" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("material-input", {
                staticClass: "position-relative",
                attrs: {
                  id: "email",
                  name: "emailNoFill",
                  placeholder: _vm.$t("global.actions.enterEmail"),
                  label: _vm.$t("global.doorr.emailAddress"),
                  type: "email",
                },
                model: {
                  value: _vm.email,
                  callback: function ($$v) {
                    _vm.email = $$v
                  },
                  expression: "email",
                },
              }),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }